export default "__VITE_ASSET__Cbtu4Y16__"